<template>
    <div class="footer">
        <div class="main">
            <!-- <div class="leftMain">
                <p>地址： 武汉市江汉区</p>
                <p>读者热线: 027-88888888</p>
            </div> -->
            <div class="rightMain">
                <img width="260px" src="../assets/images/LOGO.png">
                <span>地址： 湖北省武汉市东湖新技术开发区光谷大道特1号国际企业中心三期</span>
            </div>
            <div class="conMain">
                <h3>友情链接</h3>
                <ul>
                    <li>
                        <a href="http://lib.mnu.cn/" target="_blank">绵阳师范学院图书馆</a>
                    </li>
                    <li>
                        <a href="http://www.ndlib.com/" target="_blank">宁德市图书馆</a>
                    </li>
                    <li>
                        <a href="https://www.gxhqxx.edu.cn/" target="_blank">广西华侨学校</a>
                    </li>
                    <li>
                        <a href="http://www.jstc.edu.cn/" target="_blank">江苏旅游职业技术学院</a>
                    </li>
                    <li>
                        <a href="https://www.fjsmst.cn/" target="_blank">三明市少儿图书馆</a>
                    </li>
                    <li>
                        <a href="https://www.11467.com/quanzhou/co/19566.htm" target="_blank">安溪县图书馆</a>
                    </li>
                    
                </ul>
            </div>
            <div>
                <img src="../assets/images/微信二维码.jpg" alt="" style="width:200px">
            </div>
        </div>
    </div>
</template>

<script>

import { getUserInfo } from '@/common/utils/localStorage.js'
export default {
    name: 'Footer',
    data() {
        return {
        }
    },
    mounted() {
    },
    methods: {
    }
}
</script>

<style scoped lang="scss">
.footer {
    min-height: 250px;
    background-color: rgb(52, 60, 110);
    width: 100%;
    padding: 10px;
    box-sizing: border-box;

    .main {
        width: 1200px;
        margin: 0 auto;
        margin-top: 10px;
        color: #fff;
        display: flex;

        .leftMain {
            // width: 200px;
            margin-right: 50px;

            img {
                width: 250px;
                height: 60px;
            }

            p {
                margin-top: 20px;
            }
        }

        .conMain {
            width: 50%;

            h3 {
                margin: 20px 0;
            }

            ul {
                display: flex;
                flex-wrap: wrap;

                li {
                    margin-bottom: 20px;
                    margin-right: 50px;

                    a {
                        color: #fff;
                    }
                }
            }
        }

        .rightMain {
            // margin-top: 30px;
            margin-right: 50px;

            span {
                display: block;
                margin-bottom: 15px;
            }
        }

        .gongzonghao {
            display: flex;
            flex-direction: column;
            margin-top: 30px;
            text-align: center;

            img {
                width: 100px;
                height: 100px;
                margin-bottom: 10px;
            }

            span {
                font-size: 14px;
            }
        }
    }
}</style>



// WEBPACK FOOTER //
// src/components/Footer.vue